export const blogPostDraftOverrides: Record<string, string> = {
  '/post/almanyada-kita-nasil-bulunur': `
    <div class="blog-post-pillar">
      <p>Almanya’da çocuk bakım seçeneklerini araştırmaya başladığınızda Kita, Kindergarten, Kinderkrippe ve Tagesmutter gibi birçok farklı kavramla karşılaşabilirsiniz. İlk bakışta birbirinin yerine kullanılıyor gibi görünen bu seçenekler; çocukların yaş grubu, bakım ortamı, grup büyüklüğü ve başvuru şekli bakımından farklılaşabiliyor.</p>
      <p>Bu yazıda kendi tecrübelerimiz ışığında Kita, Kindergarten ve Tagesmutter arasındaki farkları, hangi yaş grupları için değerlendirilebileceklerini ve başvuru sürecinde nelere dikkat edebileceğinizi anlatacağım.</p>

      <h2>Kita, Kindergarten ve Tagesmutter aynı şey mi?</h2>
      <p>Tam olarak aynı değiller. Ancak günlük konuşmalarda bu kelimelerin zaman zaman birbirinin yerine kullanıldığını görebilirsiniz.</p>

      <h3>Kita nedir?</h3>
      <p>Kita, Almanca “Kindertagesstätte” kelimesinin kısaltmasıdır. Çocukların gün içerisinde bakım aldığı kurumlar için kullanılan genel bir ifadedir.</p>
      <p>Bir Kita bünyesinde farklı yaş gruplarına yönelik bölümler bulunabilir:</p>
      <ul>
        <li>Üç yaşından küçük çocuklar için Kinderkrippe</li>
        <li>Yaklaşık üç yaşından okul başlangıcına kadar olan çocuklar için Kindergarten</li>
        <li>Bazı kurumlarda okul çağındaki çocuklar için Hort</li>
      </ul>
      <p>Her kurumun kabul ettiği yaş grubu, çalışma saatleri, grup yapısı ve eğitim yaklaşımı farklı olabilir. Bu nedenle yalnızca kurumun adına bakmak yerine sunduğu bakım seçeneklerini ayrıntılı şekilde incelemek daha doğru olur.</p>

      <h3>Kindergarten nedir?</h3>
      <p>Kindergarten genellikle üç yaşından okul başlangıcına kadar olan çocuklara yönelik bakım ve erken çocukluk eğitimi sunar.</p>
      <p>Ancak kabul edilen yaş grupları ve sunulan bakım saatleri kuruma göre değişebilir. Bazı kurumlar daha küçük çocukları da kabul ederken bazıları yalnızca üç yaş ve üzerindeki çocuklarla çalışabilir.</p>
      <p>Arama yaparken kurumun internet sitesindeki yaş gruplarını ve “Betreuungszeiten” olarak belirtilen bakım saatlerini kontrol etmenizi öneririm.</p>

      <h3>Kinderkrippe nedir?</h3>
      <p>Kinderkrippe çoğunlukla üç yaşından küçük çocuklara yönelik bakım sunan kurum veya Kita bölümüdür.</p>
      <p>Çocuğunuz üç yaşından küçükse arama yaparken yalnızca “Kindergarten” kelimesini değil, şu ifadeleri de kullanabilirsiniz:</p>
      <ul>
        <li>Kinderkrippe</li>
        <li>U3-Betreuung</li>
        <li>Kita</li>
        <li>Kindertagespflege</li>
        <li>Tagesmutter</li>
        <li>Tagesvater</li>
      </ul>
      <p>Bu kelimelerle arama yapmak, yaşadığınız bölgedeki farklı bakım seçeneklerine ulaşmanızı kolaylaştırabilir.</p>

      <h3>Tagesmutter veya Tagesvater nedir?</h3>
      <p>Tagesmutter ya da Tagesvater, çocuklara çoğunlukla daha küçük bir grup içerisinde bakım sunan çocuk bakım görevlisidir. Bu bakım şekli resmî kaynaklarda “Kindertagespflege” olarak adlandırılır.</p>
      <p>Bakım; görevlinin evinde, çocuklar için hazırlanmış başka bir ortamda veya kullanılan modele bağlı olarak farklı bir yerde sunulabilir.</p>
      <p>Kindertagespflege, özellikle üç yaşından küçük çocuklar için sık karşılaşılan seçeneklerden biridir. Küçük grup yapısı ve aile ortamına daha yakın düzeni nedeniyle bazı aileler tarafından tercih edilebilir.</p>
      <p>Güncel ve ayrıntılı bilgileri <a href="https://familienportal.de/familienportal/lebenslagen/ausbildung-beruf/kinderbetreuung/was-ist-kindertagespflege--125528" target="_blank" rel="noopener noreferrer">Federal Aile Portalı’nın Kindertagespflege sayfasında</a> bulabilirsiniz.</p>

      <h2>Yaşa göre hangi bakım seçenekleri değerlendirilebilir?</h2>
      <p>Çocuğun yaşı, ihtiyaç duyulan bakım süresi ve yaşadığınız yerde bulunan kurumlara göre farklı seçenekler değerlendirilebilir:</p>
      <ul>
        <li>Üç yaşından küçük çocuklar için Kinderkrippe, U3-Betreuung ve Kindertagespflege seçenekleri yaygındır.</li>
        <li>Üç yaşından okul başlangıcına kadar Kita veya Kindergarten seçenekleri araştırılabilir.</li>
        <li>Tagesmutter veya Tagesvater, daha küçük ve aile ortamına yakın bir bakım modeli arayan aileler için alternatif olabilir.</li>
        <li>Okula başlayan çocuklar için bazı bölgelerde ders sonrasındaki saatleri kapsayan Hort veya OGS seçenekleri bulunabilir.</li>
      </ul>
      <p>Yaş grupları, başvuru dönemleri ve kabul koşulları her kurumda aynı olmayabilir. Güncel bilgileri doğrudan kurumdan veya yaşadığınız şehrin çocuk bakımı biriminden öğrenebilirsiniz.</p>

      <h2>Kita mı, Tagesmutter mı?</h2>
      <p>Bu sorunun herkes için geçerli tek bir cevabı yok. Karar verirken çocuğun yaşı, karakteri, günlük düzeni ve ailenin ihtiyaç duyduğu bakım saatleri birlikte değerlendirilmelidir.</p>
      <div class="blog-comparison-table-wrap">
        <table class="blog-comparison-table">
          <thead>
            <tr><th>Konu</th><th>Kita veya Kindergarten</th><th>Tagesmutter veya Tagesvater</th></tr>
          </thead>
          <tbody>
            <tr><td>Bakım ortamı</td><td>Daha kurumsal bir yapı</td><td>Aile ortamına daha yakın olabilir</td></tr>
            <tr><td>Grup büyüklüğü</td><td>Çoğunlukla daha kalabalık</td><td>Genellikle daha küçük</td></tr>
            <tr><td>Yaş grubu</td><td>Kurumun sunduğu gruplara göre değişir</td><td>Özellikle küçük çocuklarda yaygındır</td></tr>
            <tr><td>Bakım saatleri</td><td>Kurumun programına bağlıdır</td><td>Bakım görevlisine göre değişebilir</td></tr>
            <tr><td>Başvuru</td><td>Belediye portalı veya doğrudan kurum</td><td>Jugendamt, danışma merkezi veya yönlendirme birimi</td></tr>
          </tbody>
        </table>
      </div>
      <p>Bazı çocuklar küçük bir grupta daha kolay uyum sağlayabilir. Bazı aileler ise Kita’nın sunduğu daha geniş sosyal ortamı, etkinlikleri veya bakım saatlerini tercih edebilir.</p>
      <p>Karar vermeden önce mümkünse bakım ortamını ziyaret edebilir ve şu soruları sorabilirsiniz:</p>
      <ul>
        <li>Günlük program nasıl ilerliyor?</li>
        <li>Grupta kaç çocuk bulunuyor?</li>
        <li>Çocuklarla kaç görevli ilgileniyor?</li>
        <li>Uyum süreci nasıl yürütülüyor?</li>
        <li>Yemek ve uyku düzeni nasıl planlanıyor?</li>
        <li>Tatil ve kapalı olunan günler hangileri?</li>
        <li>Hastalık durumunda hangi kurallar uygulanıyor?</li>
        <li>Bakım saatleri çalışma düzeninize uygun mu?</li>
      </ul>

      <h2>Başvuru süreci nasıl ilerliyor?</h2>
      <p>Başvuru sistemi şehirden şehre değişebilir. Bazı şehirlerde belediyeye ait çevrim içi bir portal kullanılırken bazı yerlerde kurumlarla doğrudan iletişime geçmek gerekebilir.</p>
      <p>Genel olarak şu adımları takip edebilirsiniz:</p>
      <ol>
        <li>Yaşadığınız şehirde kullanılan başvuru sistemini öğrenin.</li>
        <li>Çocuğunuzun yaşına uygun Kita, Kindergarten ve Tagesmutter seçeneklerini araştırın.</li>
        <li>İhtiyaç duyduğunuz başlangıç tarihini ve bakım saatlerini belirleyin.</li>
        <li>Tek bir kuruma bağlı kalmadan farklı seçenekleri değerlendirin.</li>
        <li>Başvurularınızı tamamlayın ve iletişim bilgilerinizi güncel tutun.</li>
        <li>Portal hesabınızı, e-postalarınızı ve posta kutunuzu düzenli olarak kontrol edin.</li>
        <li>Bir kurumdan dönüş aldığınızda bakım şartlarını ve uyum sürecini görüşün.</li>
        <li>Kayıt için istenen belgeleri kurumun verdiği listeye göre hazırlayın.</li>
      </ol>
      <p>Özellikle nüfusun yoğun olduğu şehirlerde araştırmaya erken başlamak işinizi kolaylaştırabilir. Başvuru sürecinde yalnızca size en yakın kuruma odaklanmak yerine ulaşabileceğiniz farklı bölgelerdeki seçeneklere de bakabilirsiniz.</p>

      <h2>Köln’de başvuru nasıl yapılıyor?</h2>
      <p>Köln’de Kita ve Kindergarten için ön kayıt işlemleri genellikle Little Bird portalı üzerinden yapılabiliyor. Portalda kurumları bölgeye, yaş grubuna ve bakım saatlerine göre inceleyebilirsiniz.</p>
      <p>Bazı kurumların kendi görüşme veya kabul süreçleri olabilir. Bu nedenle portal üzerinden başvuru yaptıktan sonra seçtiğiniz kurumların internet sitelerini de kontrol etmenizi öneririm.</p>
      <p>Tagesmutter veya Tagesvater arayan aileler ise Kindertagespflege danışma ve yönlendirme birimleriyle iletişime geçebilir.</p>
      <p>Köln’de kullanılan güncel başvuru kanallarını ve iletişim bilgilerini <a href="https://www.stadt-koeln.de/leben-in-koeln/familie-kinder/betreuung/" target="_blank" rel="noopener noreferrer">Köln Belediyesi çocuk bakımı sayfasından</a> kontrol edebilirsiniz.</p>
      <p>Farklı bir şehirde yaşıyorsanız belediyenin internet sitesinde şu ifadelerle arama yapabilirsiniz:</p>
      <ul>
        <li>Kita Anmeldung</li>
        <li>Kindergartenplatz</li>
        <li>Kindertagespflege</li>
        <li>Tagesmutter Vermittlung</li>
        <li>Jugendamt Kinderbetreuung</li>
        <li>Familienbüro</li>
      </ul>

      <h2>Başvuru sırasında hangi belgeler istenebilir?</h2>
      <p>İstenen belgeler şehre ve kuruma göre değişebilir. Başvuru veya kayıt sırasında aşağıdaki belgelerden bazıları talep edilebilir:</p>
      <ul>
        <li>Çocuğun kimlik veya doğum belgesi</li>
        <li>Ebeveynlerin kimlik belgeleri</li>
        <li>Adres kayıt belgesi</li>
        <li>Çocuğun aşı veya sağlık belgeleri</li>
        <li>İhtiyaç duyulan bakım saatlerine ilişkin bilgiler</li>
        <li>Kurumun gönderdiği kayıt formları</li>
        <li>Kuruma göre ek belgeler</li>
      </ul>
      <p>Size gönderilen e-posta veya mektupta gerekli evraklar mutlaka belirtilir. Bu nedenle genel listelere güvenmek yerine kurumun size gönderdiği güncel belge listesini esas almanızı öneririm.</p>

      <h2>Bakım yeri bulunamazsa ne yapılabilir?</h2>
      <p>İlk başvurularınızdan olumlu yanıt alamamanız sürecin tamamen sonuçsuz kaldığı anlamına gelmez. Arama alanını ve değerlendirdiğiniz seçenekleri genişletebilirsiniz.</p>
      <ul>
        <li>Arama yaptığınız bölgenin çevresini genişletin.</li>
        <li>Farklı bakım saatleri sunan kurumlara bakın.</li>
        <li>Yalnızca Kindergarten değil, Kita ve Kindertagespflege seçeneklerini de değerlendirin.</li>
        <li>Belediyeye, kiliseye, derneklere veya bağımsız kuruluşlara bağlı farklı kurumları araştırın.</li>
        <li>Jugendamt veya Familienbüro ile iletişime geçin.</li>
        <li>Başvurularınızın durumunu düzenli olarak kontrol edin.</li>
        <li>Kurumlara doğrudan ulaşarak güncel durumlarını sorun.</li>
        <li>Başvurularınızı ve aldığınız cevapları düzenli şekilde kaydedin.</li>
      </ul>
      <p>Bazı kurumlarda yıl içerisinde taşınma veya ailelerin planlarının değişmesi gibi nedenlerle boşluk oluşabilir. Bu nedenle daha önce başvurduğunuz kurumların durumunu belirli aralıklarla kontrol edebilirsiniz.</p>

      <h2>Başvuru öncesi kısa kontrol listesi</h2>
      <p>Başvuru yapmadan önce şu sorulara cevap vermeniz süreci daha planlı yürütmenizi sağlayabilir:</p>
      <ul class="blog-check-list">
        <li>Çocuğunuz için hangi tarihten itibaren bakım gerekiyor?</li>
        <li>Günde kaç saatlik bakıma ihtiyacınız var?</li>
        <li>Kita mı, Tagesmutter mı, yoksa her ikisi de sizin için uygun mu?</li>
        <li>Ev veya iş yerinize yakınlık ne kadar önemli?</li>
        <li>Ulaşım için kabul edebileceğiniz mesafe nedir?</li>
        <li>Kurumun açılış ve kapanış saatleri çalışma düzeninizle uyumlu mu?</li>
        <li>Kurumun tatil ve kapalı olduğu günler hangileri?</li>
        <li>Uyum süreci için ne kadar zaman ayırabilirsiniz?</li>
        <li>Yemek, uyku ve dil desteği nasıl düzenleniyor?</li>
        <li>Çocuğunuzun göz önünde bulundurulması gereken özel bir ihtiyacı bulunuyor mu?</li>
      </ul>
      <p>Kendi sürecimizde öğrendiğimiz en önemli şeylerden biri, tek bir başvuruya güvenmemek ve farklı seçenekleri birlikte değerlendirmekti. Başvurudan sonra portal hesabını, e-postaları ve posta kutusunu düzenli takip etmek de en az başvuru yapmak kadar önemliydi.</p>

      <aside class="blog-inline-note">
        <h2>Önemli bilgilendirme</h2>
        <p>Bu yazı kişisel deneyimlerimize ve genel bilgilere dayanmaktadır. Çocuk bakımına ilişkin uygulamalar şehre, kuruma ve dönemsel kapasiteye göre değişebilir. Güncel koşulları doğrudan ilgili kurumdan, belediyenin başvuru portalından veya Jugendamt’tan kontrol etmenizi öneririz.</p>
      </aside>

      <div class="blog-inline-official-sources">
        <h2>Resmî kaynaklar</h2>
        <ul>
          <li><a href="https://familienportal.de/familienportal/lebenslagen/ausbildung-beruf/kinderbetreuung/betreuung-fuer-kleinkinder-125514" target="_blank" rel="noopener noreferrer">Federal Aile Portalı — Küçük çocuklar için bakım seçenekleri</a></li>
          <li><a href="https://familienportal.de/familienportal/lebenslagen/ausbildung-beruf/kinderbetreuung/was-ist-kindertagespflege--125528" target="_blank" rel="noopener noreferrer">Federal Aile Portalı — Kindertagespflege nedir?</a></li>
          <li><a href="https://familienportal.de/familienportal/lebenslagen/ausbildung-beruf/kinderbetreuung/wie-finde-ich-einen-kita-platz--155596" target="_blank" rel="noopener noreferrer">Federal Aile Portalı — Kita yeri nasıl bulunur?</a></li>
          <li><a href="https://www.stadt-koeln.de/leben-in-koeln/familie-kinder/betreuung/" target="_blank" rel="noopener noreferrer">Köln Belediyesi — Çocuk bakım seçenekleri</a></li>
          <li><a href="https://www.stadt-koeln.de/service/produkte/00386/index.html" target="_blank" rel="noopener noreferrer">Köln Belediyesi — Kindergarten başvurusu</a></li>
        </ul>
      </div>
    </div>
  `,
};
